export enum TipoServicoReembolsoEnum {
  PRIMEIRO_EMPLACAMENTO = "PRIMEIRO_EMPLACAMENTO",
  TRANSFERENCIA = "TRANSFERENCIA",
}
